export default "__VITE_ASSET__BiLupMWT__"